export default "__VITE_ASSET__CAqXF952__"